import { PopupDialog } from "./popupDialog";
import "../assets/css/components.css";

export const RichTextPreview = ({
  isPreviewOpen = false,
  handlePreviewClose,
  content = "",
}) => {
  return (
    <PopupDialog
      name="richTextPreview"
      open={isPreviewOpen}
      onClose={() => {
        handlePreviewClose();
      }}
      neutralAction={handlePreviewClose}
      content={
        <div className="rich-text-preview-div">
          <div
            className="rich-text-preview-inner-div"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </div>
      }
    />
  );
};
